import ReactDOM from "react-dom";
import React, { useState } from "react";
import RouteSelector from "./routeSelector/routeSelector";
import Callout from "./scheduleCallout/callout";
import ScheduleTable from "./scheduleTable/scheduleTable";
import RouteData from "../../interfaces/routes/routeData";

function ScheduleMap() {
	const container = document.getElementById("schedule-map") as HTMLElement;
	const environment = process.env.NODE_ENV;
	const localDomain =
		environment === "development" ? "https://www.capmetro-local.com" : "";
	const timetableAPI = `${localDomain}/webapi/atis/timetable`;

	const showNotification = container.dataset.notification;
	const notificationTitle = container.dataset.notificationTitle;
	const notificationContent = container.dataset.notificationContent;
	const notificationClass = container.dataset.notificationClass;
	const footerNote = document.getElementById('schedule-footer-note');

	const [selectedRoute, updateSelectedRoute] = useState<string>('');
	const [scheduleData, updateScheduleData] = useState<any>();
	const [loadingStatus, setLoadingStatus] = useState<boolean>(false);
	 
	const handleRouteClick = (e: React.SyntheticEvent) => {
		const target = e.target as HTMLElement;
		const route = target.dataset.route;
		if (route !== undefined) {
			updateSelectedRoute(route);
		}
	}

	const onRouteChange = (routeData: RouteData) => {
		const url = `${timetableAPI}/${routeData.RouteNumber}`;
		setLoadingStatus(true);
		// cant make calls to the api if not connected to the vpn
		// local development purposes only
		if (environment === 'development' || window.location.origin === 'https://www.capmetro-local.com') {
			const routeNumber = routeData.RouteNumber;
			try {
				const tableJson = require(`./demoData/routetimetable${routeNumber}.json`);
				setLoadingStatus(false);
				updateScheduleData(tableJson.Data);
				if (footerNote) {
					footerNote.hidden = false;
				}
			} catch (err) {
				const tableJson = require(`./demoData/routetimetable1.json`);
				setLoadingStatus(false);
				updateScheduleData(tableJson.Data);
			}
		} else {
			fetch(url)
				.then((response) => response.json())
				.then((data) => {
					if (data) {
						setLoadingStatus(false);
						updateScheduleData(data.Data);
						if (footerNote) {
							footerNote.hidden = false;
						}
					}
				})
				.catch((error) => { 
					setLoadingStatus(false);
					console.error('Error retrieving timetable data:', error);
				});
		}
	};
	const isRailPage =
		typeof window !== "undefined" &&
		(window.location.href || "").toLowerCase().includes("rail");

	const isBusPage =
		typeof window !== "undefined" &&
		(window.location.href || "").toLowerCase().includes("bus");
	// Header title based on URL
	const headerTitle = isBusPage ? "Select a Bus Route" : "Select a Route";


	return ReactDOM.createPortal(
		<div className="schedule-map">
            {/*===== This is the schedule map schedule Alert component. It will be used to display the schedule map alerts and related information. =======*/}
			{
				showNotification === "True" &&
				<div className={`schedule-alert ${notificationClass}`}>
					<div className="schedule-alert__container">
						<h3 className="schedule-alert__heading">{notificationTitle}</h3>
						{
							notificationContent &&
							<div dangerouslySetInnerHTML={{ __html: notificationContent }} />
						}
					</div>
				</div>
			}

			
			<div className="schedule-map__section">
				<div className="schedule-map__container">
                    {/*Start journey tool mobile callout*/}
					<div className="buttons-panel schedule-map__rail">
					<Callout type="mobile" target="schedule-callout-primary" />

					<Callout type="mobile" target="schedule-callout-secondary" />
					</div>
					{/*=====End of journey tool mobile callout =====*/}
					

					<div className="schedule-map__content">
						            {!isRailPage && (
						              <>
								                <h2 className="schedule-map__heading">
													{headerTitle}
									                </h2>
								                <br />
								                <p className="schedule-map__label">
									                  Filter Routes by type:
									                </p>
								              </>
							            )}
						<RouteSelector
							onRouteChange={onRouteChange} selectedRoute={selectedRoute}
						></RouteSelector>
					</div>
					{/*<div className="schedule-map__rail">*/}
					{/*	<Callout type="desktop" target="schedule-callout-primary" />*/}
					{/*	<Callout*/}
					{/*		type="desktop"*/}
					{/*		target="schedule-callout-secondary"*/}
					{/*	/>*/}
					{/*</div>*/}
				</div>
			</div>
           {/*===== Schedule Table Section =====*/}
			<div className="visually-hidden" aria-live="polite">
				{
					loadingStatus ? <>Loading route table results.</> : ''
				}
			</div>
			{
				loadingStatus ? (
					<div className="schedule-map__loader"><div></div><div></div><div></div></div>
				)
					: (scheduleData && (
						<div className="schedule-map__section py-xl"> 
							<div className="schedule-map__container">
								<ScheduleTable scheduleData={scheduleData}></ScheduleTable>
							</div>
						</div>
					)
					)
			}
		</div>,
		container
	);
}
export default ScheduleMap;
